import { PageInfo, PageInfoBase } from "./page-info-base.model";


export abstract class FilterBase<T> implements Filter {

    pageInfo: PageInfo = new PageInfoBase();

}

export interface Filter {
    pageInfo: PageInfo
    [key: string]: any
}